exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item.active .page-link{z-index:1;color:#fff;background-color:#50a5f1}.modal-header .close{display:none}.small-input{width:80px}.table td,.table th{padding:5px}.table{margin:0}.modal-content{background:#fff;padding:20px;border-radius:8px;text-align:center}input{margin-bottom:10px}", ""]);

// exports
